<template>
  <div class="rounded-pill px-2 py-2" :class="active ? 'active' : ''" navbutton>
    <div class="d-flex align-items-center py-1 px-4">
      <div class="fs-5 pe-3">
        <i :class="icon"></i>
      </div>
      <span class="">{{ name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavButtonComp",
  props: {
    name: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    active: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style scoped>
[navbutton] {
  cursor: pointer;
}

/* [navbutton]:hover {
} */

.active {
  background-color: rgba(255, 255, 255, 0.21);
}
</style>
